<div
  class="ea-blocked__backdrop"
  [class.ea-blocked__backdrop--visible]="isOpen()"
  aria-hidden="true"
  (click)="onDismiss()"
></div>

@if (isOpen()) {
  <section
    #dialog
    class="ea-blocked"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="ea-blocked-title"
    aria-describedby="ea-blocked-body"
    tabindex="-1"
  >
    <div class="ea-blocked__header">
      <img
        class="ea-blocked__mascot"
        src="/images/logo/info.png"
        alt=""
        loading="lazy"
        width="481"
        height="640"
      />
      <div class="ea-blocked__text">
        <h2 id="ea-blocked-title" class="ea-blocked__title">{{ copy.title }}</h2>
        <p id="ea-blocked-body" class="ea-blocked__body" aria-live="polite">
          @if (showCoin()) {
            <app-pp-coin [size]="16" />
          }
          {{ body() }}
        </p>
      </div>
    </div>

    <div class="ea-blocked__actions">
      <app-button variant="secondary" size="md" type="button" (click)="onDismiss()">
        {{ copy.secondaryCta }}
      </app-button>
      @if (actionLabel(); as label) {
        <app-button variant="primary" size="md" type="button" (click)="onAction()">
          {{ label }}
        </app-button>
      }
    </div>
  </section>
}
